var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-407 -3435) translate(0 2581) translate(0 662) translate(375 192) translate(32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.75H4.83V21.6H0zM17.987 6.924c-.05-.016-.1-.034-.153-.048-.065-.015-.13-.027-.196-.038-.257-.052-.538-.088-.867-.088-2.816 0-4.602 2.048-5.19 2.84V6.75H6.75V21.6h4.83v-8.1s3.65-5.084 5.191-1.35v9.45H21.6V11.579c0-2.244-1.538-4.113-3.613-4.655z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.363,
    cy: 2.363,
    r: 2.363
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6cf466199a7b23d915b496d925582365.svg";
export { ForwardRef as ReactComponent };